import React from "react";
import { useLocale } from "@insightfulscience/smart-react/i18";
import {
	SectionStart30DayTrial,
	SectionStart30DayTrialButton,
	SectionStart30DayTrialText,
} from "@insightfulscience/atomic-react/SectionStart30DayTrial";

const SectionInvolveYourTeam = () => {
	const [t] = useLocale("section-start-free-30-day-trial");
	return (
		<SectionStart30DayTrial>
			<SectionStart30DayTrialButton href="/demos/">{t("BUTTON_TEXT")}</SectionStart30DayTrialButton>
			<SectionStart30DayTrialText>{t("SUB_TEXT")}</SectionStart30DayTrialText>
		</SectionStart30DayTrial>
	);
};

export default SectionInvolveYourTeam;
